import styled from 'styled-components';

import { DescriptionList, Headline } from '@/components/elements';
import { laptop } from '@/components/utils';

import { ExpandableCopy } from '../ExpandableCopy';
import { Wrapper } from '../Wrapper';

export const StyledWrapper = styled(Wrapper)`
  @media screen and (${laptop}) {
    display: grid;
    grid-template-columns: repeat(12, 1fr);
  }
`;

export const StyledHeadline = styled(Headline)`
  margin-bottom: var(--distance-dynamic-s);

  @media screen and (${laptop}) {
    grid-column: 1 / span 7;
  }
`;

export const StyledDescriptionList = styled(DescriptionList)`
  margin-bottom: var(--distance-dynamic-s);

  @media screen and (${laptop}) {
    grid-column: 1 / span 7;
  }
`;

export const StyledExpandableCopy = styled(ExpandableCopy)`
  @media screen and (${laptop}) {
    grid-column: 1 / span 7;
  }
`;
